import { render, staticRenderFns } from "./BpDefinitionVertexBuilder.vue?vue&type=template&id=4d10bcd6&"
import script from "./BpDefinitionVertexBuilder.vue?vue&type=script&lang=js&"
export * from "./BpDefinitionVertexBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports